import {MI} from "../init";
import MadnesTween from "../libs/mi/MadnesTween";

/**
 * @constructor
 * @returns {undefined}
 */
export default function WinLineText() {

    /** @type {MadnesGroup} */
    //this._textsGroup;

    /** @type {number} */
    this._win = 0;

    /**
     * @type {Array<AbstractSymbol>}
     */
    this._animsSymbols = [];

    /**
     * @type {Array<MadnesObject>}
     */
    this._animsTexts = [];

    /**
     * @type {Array<MadnesObject>}
     */
    this._multiTexts = [];

}

/**
 * @param {Array<AbstractSymbol>} animsSymbols
 * @returns {undefined}
 */
WinLineText.prototype.init = function (animsSymbols, win) {
    this._win = win;
    //this._textsGroup = MI.addGroup();
    this._animsSymbols = animsSymbols;
};

/**
 * @param {number=} multiplier
 * @returns {undefined}
 */
WinLineText.prototype.createWinNormal = function(multiplier) {

    for(var i = 0; i < this._animsSymbols.length; i++) {

        var x = this._animsSymbols[i].getPosX();
        var y = this._animsSymbols[i].getPosY();
        var animText = MI.addBitmapText("font_normal_win", x, y, this._win);
        animText.setAnchor(0.5, 0.5);
        animText.setVisible(false);
        animText.shiftPosX(10, true);

        this._animsTexts.push(animText);


        if(multiplier && multiplier > 2) {
            var multi = MI.addImg(x - 60, y - 60, "multi_small_atlas").setFrameName(multiplier + "x_small")
                .setAnchor(0.5, 0.5).setVisible(false);
            this._multiTexts.push(multi);
        }

        //this._textsGroup.add(animText);
    }
};

WinLineText.prototype.playWinNormal = function() {

    return new Promise(function(res) {

        for(var i = 0; i < this._animsTexts.length; i++) {

            (function(animText, multiText) {

                multiText && multiText.setVisible(true);

                animText.setAlpha(0);
                animText.setAngle(-90);
                animText.setVisible(true);
                animText.setScale(0, 0);

                MI.addTween().to(animText, { 'angle': 0, 'alpha': 1 }, {
                    'duration': 120
                });

                MI.addTween().to(animText, { 'x': 1.16, 'y': 1.16 }, {
                    'scale': true,
                    'duration': 400,
                    'easing': MadnesTween.getEasing("back_out"),
                    'callback': function() {
                        MI.addTween().to(animText, { 'y': animText.getPosY() - 30, 'alpha': 0 }, {
                            'duration': 500,
                            'callback': function() {
                                multiText && multiText.setVisible(false);
                                res();
                            }
                        });
                    }
                });

            } (this._animsTexts[i], this._multiTexts[i]));
        }
    }.bind(this));
};

WinLineText.prototype.destroy = function() {

    /*for(var i = 0; i < this._animsSymbols.length; i++) {
        this._animsSymbols[i].destroy();
    }*/

    for(var i = 0; i < this._animsTexts.length; i++) {
        this._animsTexts[i].destroy();
    }
    this._animsTexts = [];

    for(var i = 0; i < this._multiTexts.length; i++) {
        this._multiTexts[i].destroy();
    }

    this._multiTexts = [];

    //this._textsGroup.destroy();
};